import { navTimeline } from './gsap.js';

// https://codepen.io/RSH87/pen/rmgYbo?editors=1010
export default function() {
	$(document).ready(function() {
		let menu = navTimeline();

		$(document).on('click', '.menu-icon', function(e) {
			e.preventDefault();
			$('body').toggleClass('nav-active');
			menu.reversed() ? menu.play() : menu.reverse();
		});
	});
}